import api from "./api";

const userService = {
  getAll: (params) => api.get("/users", { params }),
  getById: (id) => api.get(`/users/${id}`),
  create: (data) => api.post("/users", data),
  update: (id, data) => api.put(`/users/${id}`, data),
  remove: (id) => api.delete(`/users/${id}`),
  bulkStudents: (data) =>
    api.post("/users/bulk-students", data, { timeout: 60000 }),
  resetPassword: (id, newPw) =>
    api.post(`/auth/reset-password/${id}`, { newPassword: newPw }),
  changePassword: (currentPassword, newPassword) =>
    api.post("/auth/change-password", { currentPassword, newPassword }),
};

export default userService;
